﻿export const carouselState = function () {
	return {
		slideIndex: 0,
		carouselData: null,
		wasCycledManually: true,
		container: null,
		currentImagePath: "",
		showNavigation: false,
		slideInterval: null,
		speed: 0,
		/**
		 * INIT METHOD.
		 * Sets the initialPageLength, defaults to 10.
		 * Sets the column filter options.
		 */
		setupComponent: function ({ carouselData, showNavigation, speed }) {
			this.container = this.$refs.container;
			this.carouselData = carouselData;
			this.showNavigation = showNavigation;
			this.speed = speed;
			this.slideStart(this.speed);
		},

		get carouselItems() {
			return this.carouselData;
		},

		getCarouselItemMarkup: function () {
			if (this.carouselItems === null) {
				return "";
			}
			else if (this.carouselItems[this.slideIndex] === null) {
				return "";
			} else {
				return this.carouselItems[this.slideIndex].Contents;
			}
		},

		// Next/previous controls
		previous: function () {
			this.slideStop();
			this.slideIndex -= 1
			if (this.slideIndex < 0) {
				this.slideIndex = this.carouselData.length - 1;
			}
			this.scrollTo(this.slideIndex);
			this.slideStart(this.speed);
		},

		next: function () {
			this.slideStop();
			this.slideIndex += 1
			if (this.slideIndex > this.carouselData.length - 1) {
				this.slideIndex = 0;
			}
			this.scrollTo(this.slideIndex);
			this.slideStart(this.speed);
		},

		scrollTo: function (index) {
			this.slideIndex = index;
			let f = document.getElementsByClassName('ftui__carousel--navigation-button');
			for (let i = 0; i < f.length; i++) {
				if (i === index) {
					f[i].classList.add('ftui__carousel--navigation-button-active');
				}
				else {
					f[i].classList.remove('ftui__carousel--navigation-button-active');
				}
			}
			this.updateStyle();
		},

		updateStyle: function () {	
			if (this.carouselItems === null) {
				return "";
			}
			else if (this.carouselItems[this.slideIndex] === null) {
				return "";
			} else {
				return "background-image: url(" + this.carouselItems[this.slideIndex].ImagePath + "); " + this.carouselItems[this.slideIndex].CssStyle;
			}

		},
		
		slideStart: function (speed) {
			if (this.showNavigation) {
				this.slideInterval = setInterval(
					(function (self) {
						return function () { self.next(); }
					})(this), speed);
			}
		},

		slideStop: function () {
			clearInterval(this.slideInterval);
		},


	};
};
